import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAppState } from "../../../redux/features/appStateSlice";
import { useTheme } from "../../../components/hooks/useTheme";
import { Tabs } from "../../../components/common/Tabs";
import Contact from "./Contact";
import CustomerReservations from "./CustomerReservations";
import CustomerQuotes from "./CustomerQuotes";
import CreditCards from "./creditCards/CreditCards";
import CustomerFiles from "./CustomerFiles";
import Notes from "./notes/CustomerNotes";


const tabs = [
  {
    label: "Contact",
  },
  {
    label: "Reservations",
  },
  {
    label: "Quotes",
  },
  {
    label: "Credit Cards",
  },
  {
    label: "Files",
  },
  {
    label: "Notes",
  },
]

export const EditCustomer = () => {
  const dispatch = useDispatch();
  const { themeStyles } = useTheme();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search)
  const id = queryParams?.get('id') ?? '0';

  const [customerData, setCustomerData] = useState<any>();

  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  useEffect(() => {
    dispatch(setAppState("contacts.Customers"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <Tabs tabs={tabs} onChange={(index, tab) => hanbleTabChange(index)} activeIndex={activeIndex} />
          </div>

          <div>
            {
              activeIndex === 0 && (
                <Contact
                  idNumber={id}
                  customerData={customerData}
                  setCustomerData={setCustomerData}
                />
              )
            }

            {
              activeIndex === 1 && (
                <CustomerReservations
                  idNumber={id}
                />
              )
            }

            {
              activeIndex === 2 && (
                <CustomerQuotes
                  idNumber={id}
                />
              )
            }

            {
              activeIndex === 3 && (
                <CreditCards
                  idNumber={id}
                  customerData={customerData}
                />
              )
            }

            {
              activeIndex === 4 && (
                <CustomerFiles
                  idNumber={id}
                />
              )
            }

            {
              activeIndex === 5 && (
                <Notes
                  idNumber={id}
                />
              )
            }
          </div>
        </div>
      </div>
    </>
  );
};
